import React from 'react';
import { Box, Grid, Link as MuiLink, Paper, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import InputForm from '../../commun/input-form';
import { Login } from '@mui/icons-material';
import CustomButton from '../../commun/custom-button';
import { Link } from 'react-router-dom';
import logoRegie from '../../../assets/img/LogoRegie.png';
import theme from '../../../theme';
import './../login/login.form.scss';
import './forgotPassword.form.scss';

/**
 * Compsant qui permet de gérer le mot de passe perdu
 * @constructor
 * @param props
 */
export default function ForgetPasswordForms(
    props: Readonly<{
        validate: boolean;
        handlerClickSendMail: (e: { email: string }) => Promise<void>;
        handlerBack: () => void;
    }>
) {
    //Initialisation des valeurs
    const iniValues = {
        email: '',
    };

    return (
        <Box className="box-login">
            <Link to="/" className="login-brand" aria-label="Accueil">
                <img className="login-brand-logo" src={logoRegie} alt="Logo SDDEA" />
            </Link>

            <Grid container className="grid-login grid-forgot-password" spacing={2}>
                <Grid item xs={0} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                    <Paper className="paper-login">
                        <Typography variant="h2">Mot de passe oublié</Typography>
                        <Formik initialValues={iniValues} onSubmit={props.handlerClickSendMail}>
                            <Form>
                                <InputForm autoFocus id="email" name="email" label="E-Mail" type="email" required />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                        <CustomButton
                                            label={'Valider'}
                                            type="submit"
                                            variant="contained"
                                            testId="forgot-password-email"
                                            disabled={props.validate}
                                            element={<Login sx={{ marginLeft: '10px' }} />}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                        <Typography variant="body1">
                                            <MuiLink
                                                component={Link}
                                                to="/"
                                                className="url-text"
                                                underline="hover"
                                                sx={{ color: theme.palette.blue.main, fontSize: '0.9em' }}
                                                onClick={props.handlerBack}
                                            >
                                                Retour à la connexion
                                            </MuiLink>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Form>
                        </Formik>
                    </Paper>
                </Grid>
                <Grid item xs={0} sm={4}></Grid>
            </Grid>
        </Box>
    );
}
